import React, { Component } from 'react';
import { Row, Col, Nav, NavItem } from 'reactstrap';
//import { PaymentSupportedBrandsImg } from 'components/Common';
import { LogosBasedOnRegion } from 'components/Common';
// import COMPANY_FIRST from 'assets/images/firstdata.svg';
import COMPANY_FIRST from 'assets/images/Fiserv-logo-vector.svg';
import FPConfig from 'lib/config';

class Footer extends Component {

    state = {
        initialState: '',
        footerText: 'footer image here..'
    }

    render() {
        // commented below -FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
        // const supportedBrands = FPConfig.paymentSupportedBrands.paymentType(this.props.selectedPayment)
        //FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
       const regionBasedLogo = FPConfig.LogoBasedOnRegion.paymentType(this.props.institutionId)
        
        return(
            <footer className="container-fluid">
                <div className="container">
                    <Row>
                    <Col xs="12" sm="12" lg="7" className="footer-img"> 
                        <Nav className="mt-md-3">
                            {
                                //FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
                                (
                                    regionBasedLogo.map((regionName, i)=>(
                                        <NavItem key={i}>
                                            <LogosBasedOnRegion region={regionName} />
                                        </NavItem>                                    
                                    ))
                                  ) 
                                  // commented below -FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
                                //   (
                                //     supportedBrands.map((brand, i)=>(
                                //         <NavItem key={i}>
                                //             <PaymentSupportedBrandsImg brandName={brand} />
                                //         </NavItem>                                    
                                //     ))
                                //   )
                            }
                        </Nav>
                    </Col>
                    <Col xs="12" sm="12" lg="5" className="footerRgt-img"> 
                        <Nav>
                            <NavItem><img width="75" height="75" src={COMPANY_FIRST} alt="" title="" /></NavItem>
                        </Nav>
                    </Col>
                    </Row>
                </div>
            </footer>
        );
    }
}

export default Footer;